<div class="row mt-2">

  <!-- User Detail -->
  <app-user-detail
    *ngIf="(trainsInfo.isAdmin && trainsInfo.canUseTRM) || trainsInfo.isEmployee"
    [userUuid]="trainsInfo.userToBook"
    (navigateEvent)="goBack()"
    style="width: 100%">
  </app-user-detail>

  <div class="container">

    <!-- HEADER -->
    <div class="header">
      <h5>{{ onView === 'outward'
            ? ('train.search-result.outward-train' | translate)
            : ('train.search-result.return-train' | translate) }}</h5>

      <div class="search-data">
        <span>
          {{ onView === 'outward'
              ? trainsInfo?.searchConfig?.origin?.name + ' - ' + trainsInfo?.searchConfig?.destination?.name
              : trainsInfo?.searchConfig?.destination?.name + ' - ' + trainsInfo?.searchConfig?.origin?.name }}
        </span>
        <span>
          {{ onView === 'outward'
              ? (utilsService.formatDate(trainsInfo?.searchConfig?.departDate) | date)
              : (utilsService.formatDate(trainsInfo?.searchConfig?.returnDate) | date) }}
        </span>
      </div>

      <button class="search-button" (click)="changeSearchParams()">
        {{ "flight.result-flight.modify-search" | translate }}
      </button>
    </div>

    <!-- TRAIN RESULTS -->
    <div class="content"
         *ngIf="(onView === 'outward'
                 ? trainsInfo?.trainsList?.outward?.length > 0
                 : trainsInfo?.trainsList?.return?.length > 0)">

      <div class="results">

        <!-- Paging Previous -->
        <button class="paging-button" (click)="onView === 'outward' ? onSearch('Previous') : onSearchReturn('Previous')">
          <img src="assets/img/svg/arrow-right.svg" alt="" style="transform: rotate(-90deg);" />
          <span>{{"common.earlier" | translate}}</span>
        </button>

        <!-- Train List -->
        <div *ngFor="let train of (onView === 'outward' ? trainsInfo.trainsList.outward : trainsInfo.trainsList.return); let i = index">
          <div class="search-day" *ngIf="i === 0 || isDifferentDay(train, (onView === 'outward' ? trainsInfo.trainsList.outward[i - 1] : trainsInfo.trainsList.return[i - 1]))">
            {{ formatDate(train.departDate) }}
          </div>
          <div class="train-container">
            <div class="train">

              <!-- TIME -->
              <div class="time-container">
                <div class="hours">
                  <p>{{ train.departDate | date:'HH:mm' }}</p>
                  <img src="assets/img/svg/arrow-right.svg" alt="" />
                  <p>{{ train.arriveDate | date:'HH:mm' }}</p>
                </div>

                <div class="hours-info">
                  <span class="duration">{{ trainService.getDuration(train) }}</span>
                  <span class="changes"
                        (click)="train.sections.length > 1 ? openSectionsModal(train) : ''">
                    {{ train.sections.length > 0 ? train.sections.length - 1 : train.sections.length }}
                    {{'train.search-result.stops' | translate}}
                  </span>
                </div>
              </div>

              <!-- CARRIERS & PRICE -->
              <div class="sections-container">
                <div class="carriers">
                  <div *ngFor="let section of train.sections">
                    <p>{{ train.fareName }}</p>
                    <p>{{ getFlexibilityString(section?.flexibility) }}</p>
                  </div>
                </div>

                <div class="carriers">
                  <div *ngFor="let section of train.sections">
                    <img class="carrier-logo" [src]="trainService.getCarrierLogo(section?.carrier)" alt="Carrier logo" />
                  </div>
                </div>

                <div class="price"
                    (click)="trainService.selectTrain(train, onView, trainsInfo)"
                    [ngClass]="{'selected-train': isSelected(train, onView)}">
                  <span>{{ getTrainPrice(train) }} €</span>
                </div>
              </div>

            </div>
            <!-- Admin Permission Message -->
            <div *ngIf="!isPriceWithinRangeMethod(train) || trainsInfo.userFilters.onlyTrainAuthorization"
                style="display: flex; justify-content: center;">
              <span class="admin-permission-msg">
                {{ "authorization.permissions-required" | translate }}
              </span>
            </div>
          </div>
        </div>

        <!-- Paging Next -->
        <button class="paging-button" (click)="onView === 'outward' ? onSearch('Next') : onSearchReturn('Next')">
          <img src="assets/img/svg/arrow-right.svg" style="transform: rotate(90deg);" alt="" />
          <span>{{"common.later" | translate}}</span>
        </button>

      </div> <!-- end results -->

      <!-- SUMMARY -->
      <div class="summary">
        <div class="fixed-footer">
          <app-trains-summary
            style="width: 50%;"
            [activePage]="'result'"
            [onView]="onView"
            (onViewDepartEvent)="onViewDepart()"
            (onSearchReturnEvent)="onSearchReturn()"
            (onSelectTrainsEvent)="onSelectTrains()">
          </app-trains-summary>
        </div>

        <div style="width: 100%; margin-top: 1rem;" class="summary"
             *ngIf="trainsInfo?.selectedTrains?.selectedOutwardTrain && trainsInfo?.selectedTrains?.selectedOutwardAlternatives">
            <div *ngFor="let section of trainsInfo?.selectedTrains?.selectedOutwardTrain.sections">
              <p class="search-data">{{ 'train.outward-info' | translate }}: {{ section.origin }} - {{ section.destination }}</p>
              <p><b>{{ section?.fareName }}</b></p>
              <p>{{ section?.fareDescription }}</p>
            </div>
            <ng-container *ngIf="trainsInfo?.selectedTrains?.selectedReturnTrain && trainsInfo?.selectedTrains?.selectedReturnAlternatives">
              <div *ngFor="let section of trainsInfo?.selectedTrains?.selectedReturnTrain.sections">
                <p class="search-data">{{ 'train.return-info' | translate }}: {{ section.origin }} - {{ section.destination }}</p>
                <p><b>{{ section?.fareName }}</b></p>
                <p>{{ section?.fareDescription }}</p>
              </div>
          </ng-container>
        </div>
      </div>

    </div> <!-- end content -->

  </div> <!-- end container -->
</div> <!-- end row -->
